import dayjs from 'dayjs';
import React, { memo } from 'react';
import { PriorityTypes } from 'models/Task';
import { AdminsSelect } from 'components/common/adminsSelect';
import { Col, DatePicker, Form, FormModal, Row, Select } from 'components/index';
import { useTaskDetailsEdit } from 'components/common/tasks/general/taskInfo/edit/useTaskDetailsEdit';

export interface ITaskDetailsUpdate {
  onCancel: () => void;
  id: string;
  entity:
    | 'BRAND'
    | 'CLIENT'
    | 'ADMIN'
    | 'TASK'
    | 'SUPPLIER'
    | 'LEAD'
    | 'DEAL'
    | 'ITEM'
    | 'COUNTRY'
    | 'PURCHASE_ORDER'
    | 'PURCHASE_REQUEST';
  open?: boolean;
}

export const TaskInfoEditModal = memo<ITaskDetailsUpdate>((props) => {
  const [form] = Form.useForm();
  const { onCancel, open, id, entity } = props;
  const { onFinish, isSaveBtnDisabled, onCancelModal, isLoading } = useTaskDetailsEdit({
    onCancel,
    form,
    id,
    entity,
    open,
  });

  return (
    <FormModal
      form={form}
      title={'Update Task Details'}
      okText={'Save'}
      open={open}
      isLoading={isLoading}
      disableOkBtn={isSaveBtnDisabled}
      onCancel={onCancelModal}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label="Assign To*" name="assignedTo" rules={[{ required: true }]}>
            <AdminsSelect size={'large'} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Priority*" name="priorityLevel" rules={[{ required: true }]} initialValue="Medium">
            <Select size={'large'} options={PriorityTypes} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Due Date*" name="dueDate" rules={[{ required: true, message: 'Please select due date' }]}>
            <DatePicker
              size={'large'}
              showTime={{ format: 'HH:mm', defaultValue: dayjs('00:00', 'HH:mm'), showSecond: false }}
              format="YYYY-MM-DD HH:mm"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
});
